import apiClient from '@v/apiClient.js'
import SafeApiClient from '@v/SafeApiClient.js'
import { NotificationType } from '@v/store/notificationsModule.js'
import { parseAxiosException } from '@/helpers/exceptionParser.js'
import { currencyFormatter } from '@/helpers/intlFormatter.js'

const BriqPlugin = store => ({
  install(Vue) {
    const envIsNotProduction = window.environment !== 'production'
    Vue.prototype.$window = window
    Vue.prototype.$document = document
    Vue.prototype.$locale = window.i18n.locale
    Vue.prototype.$defaultDateFormat = 'yyyy-MM-dd'
    Vue.prototype.$defaultDateTimeFormat = 'yyyy-MM-dd, HH:ss'
    Vue.prototype.$twelvehourclock = window.i18n.twelvehourclock
    Vue.prototype.$apiClient = apiClient
    Vue.prototype.$safeApiClient = new SafeApiClient(apiClient)
    Vue.prototype.$timezone = window.i18n.timezone
    Vue.prototype.$currency = window.i18n.currency
    Vue.prototype.$formatCurrency = currencyFormatter(
      window.i18n.locale,
      window.i18n.currency,
    ).format
    const logError = envIsNotProduction
      ? console.error
      : e => {
          console.error(e)
          // todo: log to sentry or datadog
        }
    Vue.prototype.$logError = logError
    const logWarning = console.warn
    Vue.prototype.$logWarning = logWarning
    Vue.prototype.$log = console.log
    Vue.prototype.$getLocationOrigin = () => window.location.origin
    Vue.prototype.$setLocationHref = url => (window.location.href = url)
    Vue.prototype.$setLocationPath = relativeUrl =>
      (window.location.href = `${window.location.origin}/${relativeUrl}`)
    Vue.prototype.$openTab = relativeUrl =>
      window.open(`${window.location.origin}/${relativeUrl}`, '_blank')
    Vue.prototype.$businessUnitKey = window.businessUnitKey
    Vue.prototype.$environment = window.environment
    Vue.prototype.$localStorage = localStorage
    Vue.prototype.$setDocumentTitle = title =>
      (document.title = `${title} - ${window.businessUnitName} - BRIQ Bookings`)

    const notify = type => message => store.dispatch('notification/add', { type, message })
    const notifyError = notify(NotificationType.ERROR)
    const notifySuccess = notify(NotificationType.SUCCESS)
    const notifyWarning = notify(NotificationType.WARNING)
    Vue.mixin({
      methods: {
        $notifyError: notifyError,
        $notifySuccess: notifySuccess,
        $notifyWarning: notifyWarning,
      },
    })

    Vue.prototype.$handleError = ({ error, notification }) => {
      const parsedException = parseAxiosException(error)
      logError(`Error expected to originate from ${parsedException.origin}`)
      logError(parsedException.data)
      notifyError(notification || 'Something went wrong')
    }
  },
})

export default BriqPlugin
